import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Eye, EyeOff, Leaf } from "lucide-react";

export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success("Connexion réussie");
      navigate("/admin");
    } catch (err) {
      if (!err?.response) {
        toast.error(`Erreur réseau — le serveur est inaccessible. (URL: ${window.APP_CONFIG?.apiUrl || '/'} → /api/auth/login)`);
      } else {
        const msg = err.response.data?.detail || `Erreur ${err.response.status}`;
        toast.error(msg);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bone-light flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="w-12 h-12 rounded-2xl bg-sage/10 flex items-center justify-center mx-auto mb-3">
            <Leaf size={24} className="text-sage" />
          </div>
          <h1 className="font-playfair text-3xl text-charcoal">Eudemonie</h1>
          <p className="font-manrope text-xs text-charcoal-muted mt-1">Espace administrateur</p>
        </div>

        <form onSubmit={handleSubmit} data-testid="login-form" className="bg-white rounded-2xl p-8 shadow-sm border border-sage/10 space-y-5">
          <div>
            <label className="font-manrope text-xs text-charcoal-muted mb-1.5 block">Email</label>
            <input type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} placeholder="admin@eudemonie-sophro.fr"
              data-testid="login-email"
              className="w-full bg-bone/50 border border-sage/20 focus:border-sage focus:ring-1 focus:ring-sage/30 rounded-xl px-4 py-3 font-manrope text-sm text-charcoal outline-none transition-all" required />
          </div>
          <div>
            <label className="font-manrope text-xs text-charcoal-muted mb-1.5 block">Mot de passe</label>
            <div className="relative">
              <input type={showPwd ? "text" : "password"} value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} placeholder="••••••••"
                data-testid="login-password"
                className="w-full bg-bone/50 border border-sage/20 focus:border-sage focus:ring-1 focus:ring-sage/30 rounded-xl px-4 py-3 pr-11 font-manrope text-sm text-charcoal outline-none transition-all" required />
              <button type="button" onClick={() => setShowPwd(!showPwd)} className="absolute right-3 top-1/2 -translate-y-1/2 text-charcoal-muted hover:text-charcoal">
                {showPwd ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="btn-primary w-full flex items-center justify-center gap-2 disabled:opacity-60">
            {loading ? <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" /> : "Se connecter"}
          </button>
        </form>

        <p className="text-center font-manrope text-xs text-charcoal-muted mt-6">
          <a href="/" className="hover:text-sage transition-colors">Retour au site public</a>
        </p>
      </div>
    </div>
  );
}
